export default __webpack_public_path__ + "static/media/person1.d34fbdf2.jpg";